const translation = {
  app: {
    lang: 'hu-HU',
    formatDate: 'yyyy.MM.dd',
    formatTime: 'HH:mm:ss',
    formatDateAndTime: 'yyyy.MM.dd HH:mm:ss',
    formatDateAndTimeShort: 'yyyy.MM.dd HH:mm',
    formatDateTime: 'yyyy-MM-dd HH:mm:ss',
    formatDateTimeShort: 'yyyy-MM-dd HH:mm',
    consent: {
      header: 'Ez a weboldal sütiket használ',
      headerDetails: `Sütibeállítások kezelése`,
      textHTML: `Az Erste Befektetési Zrt. sütiket használ a weboldalak működtetése, a könnyebb használat és megfelelő színvonal biztosítása és a visszaélések megakadályozása érdekében. A weboldalon végzett tevékenységek nyomon követésével kifejezetten az Önt érdeklő ajánlatokról üzenetet juttathatunk el Önnek.`,
      moreInfo: `Bővebb információ`,
      necessary: 'Elengedhetetlen',
      statistics: 'Statisztikai',
      allowAll: 'Elfogadom a javasolt sütibeállításokat',
      allowSettings: `Elfogadom a beállításokat`,
      cookieSettings: `Sütibeállítások kezelése`,
      allowSelected: 'Kiválasztottak engedélyezése',
      reject: 'Elutasítom',
      details: 'részletek',
      comfyTitle: `Használatot segítő sütik`,
      comfyDescription: `Ezen sütik feltétlenül szükségesek ahhoz, hogy a felhasználók böngészhessék honlapunkat, maradéktalanul és zökkenőmentesen használhassák annak funkciót, a honlapunkon keresztül elérhető szolgáltatásokat, és lehetőséget biztosítanak a látogató által megadott adatok, beállítások megjegyzésére, hogy azokat ne kelljen egy újabb látogatáskor ismételten rögzítenie.`,
      comfyLink: `Bővebb információ a használatot segítő sütikről`,
      statTitle: `Statisztikai sütik`,
      statDescription: `Ezen sütik segítségével információt gyűjthetünk azzal kapcsolatban, hogyan használják látogatóink honlapunkat (pl. melyik oldalt nézte meg a látogató, annak mely részére kattintott, mennyi időt töltött az egyes oldalakon). Mindezek célja honlapunk és a rajta megtalálható funkciók szolgáltatások fejlesztése, ezáltal a felhasználói élmény javítása, a zavartalan és megfelelő színvonalú szolgáltatásnyújtás biztosítása. Az információ gyűjtése anonim módon történik.`,
      statLink: `Bővebb információ a honlapunkon használt statisztikai sütikről`,
    },
    estream: {
      unavailable: 'Az árfolyamszolgáltatás jelenleg nem elérhető',
      connectionInitFailed: `A$market$ piachoz kapcsolódó árfolyamszolgáltatás jelenleg nem elérhető! A rendszerben a legutóbbi elérhető árak kerülnek megjelenítésre!`,
      connectionDisconnected: `A$market$ piachoz kapcsolódó árfolyamszolgáltatás jelenleg nem elérhető! A rendszerben a legutóbbi elérhető árak kerülnek megjelenítésre!`,
      connectionReconnected: `A$market$ piachoz kapcsolódó árfolyamszolgáltatás ismét elérhető!`,
    },
    names: {
      netBroker: 'Erste Market PRO',
      chartIq: 'ChartIQ',
    },
  },
  general: {
    ok: 'Ok',
    login: 'Belépés',
    logout: 'Kilépés',
    cancel: 'Mégsem',
    back: 'Vissza',
    save: 'Mentés',
    confirm: `Megerősít`,
    confirmation: `Megerősítés`,
    continue: 'Folytatás',
    close: 'Bezárás',
    send: `Beküldés`,
    update: `Módosítás`,
    delete: 'Törlés',
    search: `Keresés`,
    refresh: 'Frissítés',
    reload: 'Újratöltés',
    piece: 'db',
    attention: 'Figyelem',
    error: {
      title: 'Hiba',
      unhandledExceptionNetwork: 'Váratlan hálózati hiba történt',
      unhandledException: 'Váratlan hiba történt ($message$)',
      serverError: 'Ismeretlen hiba történt',
      clientError: 'Váratlan hiba történt',
      tokenUpdateError: `Nem sikerült frissíteni a munkamenetet. Kérjük lépj ki és jelentkezz be újra.`,
    },
    toast: {
      warningTitle: 'Figyelmeztetés',
      errorTitle: 'Hiba',
      successTitle: 'Siker',
    },
    grid: {
      noRowsLabel: 'Nincs adat',
      footerTotalRows: 'Összes sor:',
      footerRowSelectedSingular: 'kiválasztott sor',
    },
    languageOptions: {
      hun: `Magyar`,
      eng: `Angol`,
    },
    emptySelectAll: 'Összes',
    KIDDocumentSearch: `KID dokumentum kereső`,
    KIDTooltip: `KID (Kiemelt Információs Dokumentum) kereső`,
  },
  notFound: {
    title: `A keresett oldal nem található `,
    errorId: `Egyedi hibaazonosító:`,
    toHomePage: `Ugrás a főoldalra`,
    toLogin: `Ugrás a bejelentkezésre`,
    fourOhFour: `404`,
  },
  login: {
    loginTitle: `Erste Market PRO`,
    login: `Belépés`,
    account: `Számlaszám`,
    help: `Segítség a belépéshez`,
    noAccountYet: `Nincs még számlád?`,
    contact: `Kapcsolat`,
    legalNotice: `Jogi nyilatkozat`,
    technicalInfo: `Technikai információk`,
    registration: `Regisztráció`,
    details: `Részletek`,
    item1: `Azonnali elérés hazai és külföldi részvényekhez`,
    item2: `Vizuális portfólió kimutatások`,
    item3: `Professzionális grafikonelemzés, széles eszköztárral`,
    item4: `Személyre szabható kereskedési felület`,
    error: {
      general: `A bejelentkezés jelenleg nem lehetséges, kérjük, próbáld később.`,
      authError: `Érvénytelen felhasználó`,
    },
    wrongSMSCode3Times: {
      title: `Érvénytelen SMS kód`,
      message: `Kezdd újra a bejelentkezést.`,
    },
  },
  unsuccessfulLoginModal: {
    title: `Sikertelen bejelentkezés`,
    titleTechnical: `Technikai hiba`,
    textTechnical: `A bejelentkezés nem sikerült, kérjük próbáld később.`,
    subtitle: `Hiba történt`,
    errorCode: `Egyedi hibaazonosító:`,
    button: `Vissza a belépésre`,
    errors: {
      SignInErrorUnknown: 'Ismeretlen hiba történt',
      SignInFailedToInitializeApp: 'Az alkalmazást nem sikerült betölteni',
      ConsentFirstLoginMissing: 'Az első belépési tájékoztatót nem tudtuk betölteni',
      ConsentFirstLoginRejected: 'Az első belépési tájékoztatót elutasítottad',
      TokenExpired: 'A munkamenet lejárt',
      SSOAuthError: 'Hiba történt a bejelentkezés során, kérjük, próbáld újra később',
      InactivityTimeout: 'Inaktivitás miatt kiléptettünk',
      ErrorWhileSavingConsent: 'A bejelentkezés nem sikerült, kérjük próbáld később.',
    },
    userDisabled: {
      lead: 'Kedves Ügyfelünk!',
      subLead: 'Az internetes hozzáférésed jelenleg technikai okok miatt nem aktív.',
      content: `Kérjük, vedd fel a kapcsolatot az Erste Befektetési Zrt. munkatársaival a 06 1 2355 151-es telefonszámon vagy az <a href="mailto:info@ersteinvestment.hu">info@ersteinvestment.hu</a> email címen.<br/>&nbsp<br/>
Üdvözlettel:<br/>
Erste Befektetési Zrt.`,
    },
  },
  mifidModal: {
    title: `Mifid kérdőív figyelmeztetés`,
    ok: `Rendben`,
  },
  firstTimeLoginModal: {
    title: `Ügyletkötést megelőző tájékoztatás`,
    description: `A megbízás megadásának véglegesítésével az Ügyfél kijelenti, hogy a megadott adatokat teljes körűen ellenőrizte és az ajánlat megadására vonatkozó visszavonhatatlan szándéka fennáll, és kijelenti továbbá az alábbiakat: Ügyfél hatályos keretszerződései és az Üzletszabályzat tartalmát megismerte, elfogadja, valamint amennyiben az ügylet megkötése előtt figyelmeztetés jelenik/jelent meg, elfogadja a figyelmeztető szövegben foglaltakat. Mindezeken kívül tudomása van arról, hogy jelen szerződésre ezek és az Üzletszabályzat, a Társaság befektetési hitel, day-trade shortra, és/vagy az Internetes hirdetményben rögzített bármely más ügylettípusra irányadó speciális rendelkezései továbbá a Ptk., és az ágazati jogszabályok rendelkezései alkalmazandók, ezeket az Ügyfél kifejezetten elfogadja. A tranzakció a személyi jövedelemadóról szóló 1995. évi CXVII. törvény (Szja tv.) mindenkor hatályos szabályai szerint adózik. Az adózási tudnivalók nem tartalmaznak teljes körű információkat. Kérjük, döntése meghozatala előtt részletesen tájékozódjon az adózási kérdésekkel kapcsolatos jogszabályi feltételekről, valamint konzultáljon adótanácsadójával. Az adójogszabályok és azok értelmezései változhatnak, az abból fakadó következményekért a Társaság nem tehető felelőssé.
<br><br>
Amennyiben a tranzakció alapján befektetési hitel nyújtására kerül sor, az Ügyfél kifejezetten elfogadja, hogyha kifejezetten nem jelzi a Társaság felé, hogy a Futamidő lejáratakor nem kéri a (további) prolongálást, úgy az úgy tekintendő, hogy az Ügyfél kérelmezi a futamidő meghosszabbítását.
<br><br>
Kérjük, hogy ajánlata megadásakor vegye figyelembe, hogy az 596/2014/EU rendelet alapján tilos az olyan ügylet, mely hamis vagy félrevezető jelzéseket ad/adhat a termék kínálata, kereslete vagy ára tekintetében, illetve a szokásostól eltérő vagy mesterséges szinten rögzíti/rögzítheti a termék árát. Az ilyen ügylet tiltott piacbefolyásolásnak minősülhet, mely a Btk. 411. § alapján büntetendő.
<br><br>
Az Ügyfél elfogadja, hogy amennyiben másképp nem rendelkezik, eladási megbízás rögzítése esetén az értékpapír azon a piacon kerül eladásra, ahol az értékpapír megvételre került. A Társaság végrehajtási politikája szerint, ha az Ügyfél a megbízás végrehajtását illetően speciális instrukciót ad, akkor a Társaság a megbízást ezen instrukció mentén hajtja végre. Az ügyfélnek azonban tudatában kell lennie annak, hogy bármely speciális instrukció a Társaságot megakadályozhatja abban, hogy a Végrehajtási politikában megtervezett és kialakított lépéseket megtegye a lehető legkedvezőbb eredmény elérése érdekében a megbízás végrehajtásakor.
<br><br>
Az Ügyfél megbízás megadásának véglegesítésével kijelenti, hogy Társaság e szerződés megkötése előtt a Bszt. szerinti valamennyi tájékoztatást megadta, részére elérhető módon rendelkezésére bocsátotta - többek között - a szerződésben megjelölt termékkel, annak piacával, a kapcsolódó kockázatokkal, a szolgáltatással, valamint szolgáltatóval kapcsolatosan és befektetési döntését ezek alapul vételével hozta meg.
<br><br>
Felek jelen megbízással kapcsolatos jogvitáikra – beleértve a megbízás elfogadásának megtagadását is – a magyar bíróságok hatáskörét és illetékességét kötik ki.
Beleegyezem, hogy az előzetes költség és díj tájékoztatást (<a href="https://www.erstemarket.hu/oldalak/elozetes-koltseg" target="_blank" rel="“noopener" noreferrer”>https://www.erstemarket.hu/oldalak/elozetes-koltseg</a>), a csomagtermékekről a kiemelt információs dokumentumot (<a href="https://kid.ersteinvestment.hu" target="_blank" rel="“noopener" noreferrer”>https://kid.ersteinvestment.hu</a>), a végrehajtási politikát (<a href="https://www.erstemarket.hu/dokumentumok/uzletszabalyzat" target="_blank" rel="“noopener" noreferrer”>https://www.erstemarket.hu/dokumentumok/uzletszabalyzat</a>), a pénzügyi eszközökre vonatkozó tájékoztatást  (<a href="https://www.erstemarket.hu/dokumentumok/termek-koltsegtajekoztatok" target="_blank" rel="“noopener" noreferrer”>https://www.erstemarket.hu/dokumentumok/termek-koltsegtajekoztatok</a>) és jogszabály által előírt egyéb tájékoztatási anyagokat a Társaság az internetes honlapján tegye számomra elérhetővé, továbbá általánosan hozzájárulok, hogy a megbízásaimat a Társaság kereskedési helyszínen kívül hajtsa végre.
<br><br>
Ügyfél tudomásul veszi, hogy a Társaság  a megbízások teljesítéséről az Ügyfelet az Megbízási naplóban értesíti.
<br><br>
Az alábbi tájékoztatásokat megismertem:
`,
    preliminaryCost: `Előzetes költség és díj tájékoztatás megnyitása`,
    ETFInfo: `Részvény és ETF terméktájékoztató megnyitása`,
    KID: `Kiemelt információs dokumentum kereső megnyitása`,
    tooltip: `Kattints a tájékoztató megtekintéséhez`,
    button: `A fentiekben foglaltakkal egyetértek`,
  },
  header: {
    info: `Kérjük válassz számlát!`,
    infoIfCurrencyExchange: `A devizaváltáshoz válassz ki egy számlát!`,
    allAccounts: 'Minden számla',
    accountCount: `$accountCount$ számla`,
    accountBalanceValue: 'Számlaérték',
    accountBalanceTooltip: `Számlaérték: A számlaérték az értékpapírszámlának vagy kiválasztott alszámlának összesített értékét jelenti, amely az alábbiakat tartalmazza:<br> <br>
- a számlán található értékpapírok legutolsó ismert árfolyamon számított értékét,<br> <br>
- a derivatív pozíciókon nem realizált nyereséget és veszteséget,<br> <br>
- valamint az elérhető szabad pénzegyenlegeket.<br> <br>
A számlaérték nem tartalmazza a befektetési hitel összegét.<br> <br>
A tőzsdei értékpapírok értékelése, késleltetett vagy valós idejű árfolyamok alapján történik, az adatszolgáltatási előfizetésétől függően. Ha online nem kereskedhető értékpapírról van szó, akkor előző napi záróárfolyam alapján kerül értékelésre. <br>
A számlaérték összesítése forintban történik, a legutolsó ismert (15 percel késleltetett) devizaárfolyamok alapján.`,
    floatingResult: 'Nem realizált eredmény',
    floatingResultTooltip: `A nem realizált eredmény az értékpapírszámlán található eszközökön elért aktuális nyereség és veszteség forintban összesítve. Az értékelés az utolsó ismert árfolyamon történik, amely lehet előző napi záró árfolyam az Erste Market PRO-ban nem elérhető tőzsdei termékek esetén, késleltetett árfolyam vagy valós idejű árfolyam az előfizetett adatszolgáltatási csomagok alapján.`,
    cashBalance: 'Szabad pénz',
    cash: {
      title: 'Készpénz',
      exchange: `Devizatranzakció`,
      deposit: `Befizetés`,
      transfer: `Átvezetés`,
      allocation: `Kiutalás`,
      total: `Forintban összesen`,
      allocatedTooltip: `A teljes egyenleg nyitott megbízások fedezetére elkülönített része`,
      availableInvestmentLoan: 'Elérhető befektetési hitel',
      availableInvestmentLoanError: 'Elérhető befektetési hitel betöltése sikertelen',
      availableInvestmentLoanTooltip: `A feltüntetett érték tájékoztató jellegű, az elérhető befektetési hitel mértéke eltérhet az egyes papírok beszámítási értékétől (diszkontérték) függően (ld. Fedezeti Eszközök Hirdetmény).
A befektetési hitel igénybevételének feltétele a Kiegészítő megállapodás komplex ügyletekre szerződés elfogadása a régi NetBroker felületen.
A tőkeáttételes kereskedés kiemelten magas kockázattal jár, kérjük befektetési hitel igénybevétele előtt ismerd meg a kapcsolódó ügylet előtti tájékoztatást (ÜET).`,
    },
    cashEmpty: {
      title: `Nincs a számlán szabad egyenleg.`,
      text1: `Egyenleged feltöltheted a régi NetBroker felületén, vagy külső számláról az alábbi számlára való utalással:`,
      text2: `Ha közleményben megjelölöd a célszámlát (pl.: TBSZ 2024), az összeget közvetlenül oda írjuk jóvá.`,
      noCashTitle: `Nincs a számlán szabad pénz`,
      noCashDepositTransferText: `Egyenleged feltöltheted befizetéssel bankszámláról, vagy átvezetéssel egy másik befektetési számláról`,
      noCashDepositOnlyText: `Egyenleged feltöltheted befizetéssel bankszámláról`,
    },
    exchange: {
      title: 'Árfolyam szolgáltatás',
      realTime: 'Valósidejű',
      noAccess: 'Nincs kapcsolat',
      delay: `$min$ perc késleltetés`,
      error: `A szolgáltatás információ nem elérhető`,
    },
    search: `Értékpapír kereső`,
  },
  cashAction: {
    contract: 'Internetes átvezetési szerződés',
    summary: {
      header: 'Összesítő',
      sourceAccount: 'Forrás számla',
      targetAccount: 'Cél számla',
      deposit: {
        title: 'Befizetés',
        amountLabel: 'Befizetett összeg',
        submit: 'Befizetés',
      },
      transfer: {
        title: 'Átvezetés',
        submit: 'Átvezetés',
        amountLabel: 'Átvezetett összeg',
      },
      allocation: {
        title: 'Kiutalás',
        submit: 'Kiutalás',
        amountLabel: 'Kiutalt összeg',
      },
    },
    paramEditor: {
      error: {
        deposit: {
          cannotBeZero: 'A befizetés összege nem lehet 0',
          cannotExceedSourceAmount: 'A befizetés összege meghaladja a számlaértéket!',
        },
        transfer: {
          cannotBeZero: 'Az átvezetés összege nem lehet 0',
          cannotExceedSourceAmount: 'Az átvezetni kívánt összeg meghaladja a számlaértéket!',
        },
        allocation: {
          cannotBeZero: 'A kiutalás összege nem lehet 0',
          cannotExceedSourceAmount: 'A kiutalás összege meghaladja a számlaértéket!',
        },
      },
    },
    confirm: {
      description: 'Írd be a mentett telefonszámra SMS-ben kapott kódot a két faktoros hitelesítéshez',
      smsCodeLabel: 'SMS kód',
      deposit: {
        title: 'Befizetés kétfaktoros megerősítése',
        submit: 'Befizetés megerősítése',
      },
      transfer: {
        title: 'Átvezetés kétfaktoros megerősítése',
        submit: 'Átvezetés megerősítése',
      },
      allocation: {
        title: 'Kiutalás kétfaktoros megerősítése',
        submit: 'Kiutalás megerősítése',
      },
    },
    deposit: {
      title: 'Befizetés',
      tabs: {
        fromErste: 'Erste számláról',
        fromOutside: 'Bankon kívülről',
      },
      external: {
        currencyLabel: 'Deviza',
        detailsTitle: 'Befizetési adatok',
        detailsLabel: {
          clientName: 'Kedvezményezett neve',
          accountNumber: 'Számlaszám',
          iban: 'IBAN',
          bicCode: 'BIC (SWIFT)',
          announcement: 'Közlemény',
        },
        warning: {
          title: 'Figyelem',
          message:
            'Utaláskor győződj meg arról, hogy a közleményben pontosan szerepeljen a teljes neved és 7 számjegyű ügyfélkódod.',
        },
        info: {
          title: 'Befizetés számlára',
          message:
            'Ha az utalás közleményében megadod a cél alszámla azonosítóját (pl.: TBSZ2026, NYESZ-R), akkor az összeget automatikusan arra az alszámlára vezetjük át.',
        },
      },
      internal: {
        currencyLabel: 'Deviza',
        sourceAccountLabel: 'Forrás számla',
        targetAccountLabel: 'Célszámla',
        balanceLabel: 'Egyenleg',
        totalDeposits: 'Összes befizetése',
        balanceFallback: '-',
        submit: 'Befizetés',
      },
      error: {
        contract: 'Internetes átvezetési szerződés',
        noConnectedAccountTitleHUF:
          'Erste bankszámláról történő befizetéshez először össze kell kötnöd a bankszámládat az értékpapírszámláddal.',
        noConnectedAccountContentHUFFirstHalf: 'Ezt a régi Netbroker felületén tudod megtenni az ',
        noConnectedAccountContentHUFSecondHalf:
          ' elfogadásával. A befizetés azért is sikertelen lehet, ha ugyan össze van már kötve a számlád, de az egyenlenged 0 HUF. Ha még nincs Erste bankszámlád, kérjük, keresd fel bármely Erste Bank fiókot.',
        noConnectedAccountTitle:
          'Erste bankszámláról történő befizetéshez kösd össze meglévő Erste deviza bankszámládat értékpapírszámláddal.',
        noConnectedAccountContentFirstHalf: 'Ezt megteheted a régi Netbroker felületen az ',
        noConnectedAccountContentSecondHalf:
          ' elfogadásával. A befizetés azért is sikertelen lehet, ha ugyan össze van már kötve a számlád, de az egyenlenged 0 $currency$. Ha még nem rendelkezel Erste deviza bankszámlával, akkor kérjük, keresd fel bármely Erste Bank fiókot.',
        noConnectedAccountContentSecondHalfWithoutCurrency:
          ' elfogadásával. A befizetés azért is sikertelen lehet, ha ugyan össze van már kötve a számlád, de 0 az egyenlenged. Ha még nem rendelkezel Erste deviza bankszámlával, akkor kérjük, keresd fel bármely Erste Bank fiókot.',
        cannotLoadDeposit: 'Rendszer terheltség miatt a befizetés Erste számláról jelenleg nem elérhető.',
      },
    },
    transfer: {
      title: 'Átvezetés',
      transferAll: 'Összes átvezetése',
      submitButtonText: 'Átvezetés',
      error: {
        cannotLoadTransfer: 'Rendszer terheltség miatt az átvezetés jelenleg nem elérhető.',
        noSourceAccountTitle: 'Jelenleg nincs olyan számlád amiről tudnál átvezetést indítani vagy fogadni.',
        noSourceAccountTitleForSelectedSource:
          'A kiválasztott forrásszámládhoz nincs olyan célszámlád amire tudnál átvezetést indítani vagy fogadni.',
        noSourceAccountContent:
          'A folytatáshoz nyiss egy alszámlát, TBSZ-t vagy NYESZ-R számlát. TBSZ és NYESZ-R számláról online nem tudsz más számlára átvezetni, mert ez a számlák megszüntetését eredményezné. NYESZ-R számlára csak forint átvezetése lehetséges.',
      },
    },
    allocation: {
      title: 'Kiutalás',
      allocateAll: 'Összes kiutalása',
      submitButtonText: 'Kiutalás',
      error: {
        cannotLoadAllocation: 'Rendszer terheltség miatt a kiutalás jelenleg nem elérhető.',
        noConnectedAccountTitleHUF:
          'Erste bankszámlára történő kiutaláshoz kösd össze meglévő Erste bankszámládat értékpapírszámláddal.',
        noConnectedAccountContentHUFFirstHalf: 'Ezt a régi Netbroker felületén tudod megtenni az ',
        noConnectedAccountContentHUFSecondHalf:
          ' elfogadásával. A kiutalás azért is sikertelen lehet, ha ugyan össze van már kötve a számlád, de az egyenleged 0 HUF. TBSZ és NYESZ-R számláról online nem tudsz más számlára kiutalni, mert ez a számlák megszüntetését eredményezné.',
        noConnectedAccountTitle:
          'Erste bankszámlára történő kiutaláshoz kösd össze meglévő Erste deviza bankszámládat értékpapírszámláddal.',
        noConnectedAccountContentFirstHalf: 'Ezt a régi Netbroker felületén tudod megtenni az ',
        noConnectedAccountContentSecondHalf:
          ' elfogadásával. A kiutalás azért is sikertelen lehet, ha ugyan össze van már kötve a számlád, de az egyenleged 0 $currency$. TBSZ és NYESZ-R számláról online nem tudsz más számlára kiutalni, mert ez a számlák megszüntetését eredményezné.',
        noConnectedAccountContentSecondHalfWithoutCurrency:
          ' elfogadásával. A kiutalás azért is sikertelen lehet, ha ugyan össze van már kötve a számlád, de 0 az egyenleged. TBSZ és NYESZ-R számláról online nem tudsz más számlára kiutalni, mert ez a számlák megszüntetését eredményezné.',
      },
    },
    errorsCommon: {
      cannotSubmit: 'Technikai okok miatt nem tudjuk rögzíteni a megbízást, kérjük próbáld újra később.',
      cannotLoadScreen: 'Nem sikerült betölteni a képernyőt, kérjük gyere vissza később vagy nyomd meg a frissítést.',
    },
  },
  currencyChange: {
    error: {
      loadSourceCurrenciesFailed: `Nem sikerült betölteni a forrásdevizákat`,
      loadTargetCurrenciesFailed: `Nem sikerült betölteni a céldevizákat`,
      selectedPairNotAvailable: `A kiválasztott devizapár váltása jelenleg technikai okokból szünetel. Próbáld később, vagy válassz másik devizapárt.`,
    },
    title: `Devizatranzakció`,
    goBack: `Vissza`,
    goToSummary: `Váltás`,
    confirmExchange: `Megerősít`,
    startExchange: `Tovább`,
    sourceCurrency: `Forrásdeviza`,
    selectSourceCurrency: `Válassz forrásdevizát`,
    targetCurrency: `Céldeviza`,
    selectTargetCurrency: `Válassz céldevizát`,
    balance: `Egyenleg`,
    changeAll: `Összes váltása`,
    exchangeRate: `Árfolyam`,
    exchangeRateFailed: `Az árfolyam nem tölthető be, próbáld meg később`,
    settlementDay: `Elszámolás napja`,
    info: `$tBalance$ összeghatárig a devizaváltás adott napon belül teljesül, mivel az összeg 30 napon belül volt befektetve. Ennél magasabb váltott összegnél az üzletszabályzat szerinti devizaügylet keretében T+3 napos teljesülés esedékes.`,
    tDayChangeInfo: `$tBalance$ összeghatárig lehetőség van a devizatranzakció napon belüli elszámolására, mivel az összeg 30 napon belül volt befektetve.`,
    tDayChange: `Napon belül szeretnék váltani`,
    tDayBalance: `Napon belüli elszámolással felhasználható`,
    tDaySourceTooHigh: `A beírt összeg magasabb mint az adott napi teljesüléssel felhasználható egyenleg. A rendszer automatikusan megadta a lehetséges maximumot. Ennél magasabb összeg váltásához kapcsold ki a “Napon belül szeretnék váltani” opciót`,
    timeUp: `Időtúllépés miatt új kalkuláció készült!`,
    warningTooHighSource: `A beírt összeg meghaladja a forrásdeviza egyenleget.`,
    warningTooHighTarget: `Nem áll rendelkezésre elég fedezet a beírt összeg váltására. A rendszer automatikusan megadta a lehetséges maximumot az adott árfolyamon.`,
    errorDailyMax: `A beírt összeg túllépi a napon belüli maximum tranzakciós limitet.`,
    errorTransactionalMax: `A megadott összeg meghaladja az egy tranzakción belüli maximálisan váltható limitet. Aktuális limitek: `,
    warningMinimumAmount: `Frissítettük az összeget, mert devizatranzakciónál nem lehet 1 egységnél kisebb egyik devizából sem.`,
    errorMinimumAmount: `Nem áll rendelkezésre elengendő összeg a devizatranzakció indításához. Mert 1 egységnél kisebb egyik devizából sem lehet.`,
    actualLimitsLinkTitle: `Erste Befektetési Zrt. - Devizaváltás`,
    tooltipSettlementTDay: `Üzletszabályzat szerinti devizaváltás.`,
    tooltipSettlementT3Day: `Üzletszabályzat szerinti devizaügylet.`,
    changeAllAvailableAmount: `Teljes tranzakcióérték váltása`,
    changeMissingAmount: 'Hiányzó összeg váltása',
    summary: {
      title: `Összesítő`,
      amount: `Mennyiség`,
      orderValue: `Megbízás értéke`,
    },
    note: {
      currentlyNoExchange: `Jelenleg a devizaváltás szünetel`,
      noExchangePeriod: `Jelenleg nincs devizatranzakciós időszak`,
      noExchangePeriodForCurrency: `Jelenleg nincs $currency$ váltási időszak`,
      tryLater: `Próbáld újra később!`,
      error: `Technikai hiba történt`,
      globalLimitExceeded: `Jelenleg a(z) $currency$ váltása elérte a szolgáltatói limitet`,
      highExchange: `Jelenleg a(z) $currency$ váltása magas árfolyambeli eltérés miatt szünetel`,
      tryLaterWithoutLimit: `A folyamatos tranzakciók miatt ez változhat, ezért próbáld újra később, vagy a következő limitmentes időszakban:`,
      tryLaterFixTime: `Próbáld újra az alábbi időpontokban:`,
      nonNightExchangePeriod: `Hétfő-Péntek 08:00-17:00`,
      withNightExchangePeriod: `Hétfő-Péntek 08:00-22:00`,
      limitFreeExchangePeriod: `Hétfő-Péntek 08:00-17:00`,
      unavailable: `Az adott deviza nem váltható`,
    },
    twoFactor: {
      header: 'Kétfaktoros megerősítés',
      label: 'Írd be az SMS-ben kapott kódot',
      failed: `Tranzakció megerősítése nem sikerült. A folyamat újrakezdése szükséges.`,
    },
  },
  indexRow: {
    simplifiedDisplayNameDict: {
      SX50UL: 'US 500',
      SXXE: 'EU 50',
      SX18GP: 'UK 180',
      EDE15BP: 'Emerging 1500',
      SX21HP: 'Hong Kong 210',
      SX60JP: 'Japan 600',
      TCCNP: 'China Total',
    },
    error: 'A grafikon nem elérhető',
  },
  search: {},
  instrument: {
    search: {
      title: `Értékpapír kereső`,
      instruments: `pl. Termék neve, ticker, ISIN`,
      noResult: `Nincs találat!`,
      errorResult: 'Hiba a keresés közben!',
      order: `Megbízás`,
      tooltip: {
        newOrder: `Új megbízás`,
        nonTradeable: `Az instrumentumra ajánlat nem adható`,
        addToWatchlist: `Hozzáadás figyelőlistához`,
        openChart: `Grafikon megnyitása`,
        priceAlert: `Árfolyamértesítő rögzítése`,
        productPage: `Termékadatlap megnyitása`,
      },
    },
    saveToWatchlist: {
      full: `Betelt`,
      chooseWatchlist: `Figyelőlista választása`,
    },
    unknown: `Ismeretlen termék`,
    price: {
      delayed: 'Késleltetett',
      closePrice: 'Előző záró ár',
      indicative: 'Indikatív ár',
      lastKnown: 'Utolsó ismert ár',
    },
  },
  productDetailsModal: {
    title: `Adatlap`,
  },
  logoutModal: {
    title: `Figyelem`,
    titleAfterTimeout: `Inaktivitás miatti kiléptetés`,
    text: `perc inaktivitás után biztonsági okból kiléptetünk a rendszerből.<br> <br>A kilépés gomb megnyomásával biztonságosan kijelentkezhetsz a rendszerből. A mégsem gombra kattintva meghosszabbíthatod jelenlegi munkameneted.<br> <br>Jelenleg 15 perc inaktivitás után kerül sor automatikus kiléptetésre. A beállítás megváltoztatható a felületi beállítások menüpontban.`,
    textAfterTimeout: `Biztonsága érdekében a rendszer kiléptette.`,
  },
  menu: {
    dashboard: 'Kezdőlap',
    trading: 'Kereskedés',
    stockTrading: 'Tőzsdei kereskedés',
    watchList: 'Figyelőlista',
    chart: 'Grafikon',
    portfolio: 'Portfólió',
    settings: 'Beállítások',
    userSettings: `Felhasználói beállítások`,
    notificationsSettings: `Értesítési beállítások`,
    siteSettings: `Felületi beállítások`,
    dataServiceManagement: `Adatszolgáltatási beállítások`,
    feedback: `Visszajelzés`,
    logout: `Kilépés`,
  },
  widget: {
    header: {
      SimpleTradeTicket: 'Villám kötjegy',
      TradeTicket: 'Teljes kötjegy',
      OrderBook: 'Ajánlati könyv',
      ProductDetails: 'Termék adatlap',
      WatchList: 'Figyelőlista',
      Chart: 'Grafikon',
      NetPositions: 'Nettó pozíciók',
      OpenOrders: 'Nyitott megbízások',
      BETFillList: 'BÉT kötéslista',
      OpenPositions: 'Tőzsdei befektetések',
      Order: 'Normál kötjegy',
      PriceAlerts: 'Árfolyamértesítők',
      OrderLog: `Megbízási napló`,
      PortfolioComposition: `Portfólió összetétel`,
      CollateralSummary: `Fedezet összesítő`,
      HistoricalPortfolioValue: 'Historikus portfólió érték',
    },
    categories: {
      Bidding: 'Ajánlatadás',
      Market: 'Piacfigyelés',
      Portfolio: 'Portfólió',
    },
  },
  watchList: {
    title: 'Figyelőlista',
    addNewList: `Új lista létrehozása`,
    addNewInstrument: `Instrumentum hozzáadása`,
    newListPlaceholder: `Új lista címe`,
    searchNewInstrumentPlaceholder: `Új termék keresése`,
    editLists: `Listák szerkesztése`,
    confirmDelete: `Biztosan törlöd a listát?`,
    confirmClearList: `Biztosan kiüríted a listát?`,
    editor: {
      listIsAlreadyAdded: `Már létezik ilyen nevű lista`,
      listIsCreated: `Új figyelőlista sikeresen hozzáadva!`,
      listIsUpdated: `Figyelőlista frissítve!`,
      itemIsCreated: `Ez az instrumentum már hozzá van adva!`,
      instrumentCannotBeAdded: `Nem sikerült hozzáadni a terméket a figyelőlistához`,
      confirmDeleteInstrument: `Biztosan törlöd a $name$ terméket a figyelőlistáról?`,
      instrumentCannotBeDeleted: `Nem sikerült törölni a terméket a figyelőlistáról`,
      searchPlaceholder: `Értékpapír hozzáadása`,
      watchlistIsFull: `A lista elemszáma elérte a maximális 100 darabot.`,
    },
    emptyList: 'Üres lista kattints a + gombra új instrumentum hozzáadásához',
    watchListGroupsReorderFailed: `Nem sikerült elmenteni az új sorrendet`,
    watchListGroupWarning: `A listák száma elérte a maximális 10 darabot.`,
    watchlistInstrumentWarning: `A lista elemszáma elérte a maximális 100 darabot.`,
    defaultsPopover: {
      header: 'Alapértelmezett listák',
      error: 'Újra',
    },
  },
  watchListTab: {
    domesticStock: `Hazai részvény`,
    internationalStock: `Külföldi részvény`,
    eft: `ETF`,
    certificate: `Certifikát`,
  },
  watchListGrid: {
    instrumentDefault: `Instrumentum adatlap`,
    change: `Vált.`,
    description: `Description`,
    add: `Hozzáadás`,
    notification: `Értesítő beállítása`,
    chart: `Chart megnyitása`,
    delete: `Törlés`,
    more: `Több`,
    grid: {
      instrument: `Ticker`,
      closePrice: `Záró ár`,
      lastPrice: `Utolsó ár`,
      change: `Változás`,
      changePercent: `Változás %`,
      bidPrice: `Eladás`,
      askPrice: `Vétel`,
      low: `Napi min.`,
      high: `Napi max.`,
      averagePrice: `Napi átlag`,
      volumeQuantity: `Forg. (db)`,
      volumeValue: `Forg. (érték)`,
      annualLow: `52 heti min.`,
      annualHigh: `52 heti max.`,
      name: `Név`,
      market: `Piac`,
      currency: `Deviza`,
      strikePrice: `Kötési ár`,
      strikeBarrier: `Korlát ár`,
      bidPriceTooltip: `Eladási megbízás adása`,
      askPriceTooltip: `Vételi megbízás adása`,
    },
    context: {
      details: `Termékadatlap`,
      order: `Megbízás`,
      notification: `Árfolyamriasztás`,
      chart: `Chart megnyitása`,
      deleteRow: `Sor törlése`,
    },
  },
  simpleTradeTicket: {
    sell: 'Eladás',
    buy: 'Vétel',
    marketPrice: 'Piaci ár',
    limitPrice: 'Limit ár',
    quantity: 'Mennyiség',
    stock: 'Készlet',
    piece: '$piece$ db',
    stockTooltip: `A mennyiség mezőt a saját szabad készlettel tölti ki.`,
    deltaTooltip: `Deltakockázat: $delta$`,
    expectedCost: 'Várható költség',
    totalValue: 'Összérték',
    costCalculationError: 'A költségek kiszámítása sikertelen',
    multipleAccountError: `A költségek kiszámításához válassz számlát!`,
    nonTradeableInstrument: `Az instrumentumra villámkötjegy nem elérhető`,
    middlePrice: {
      label: 'Közép ár',
      tooltip: 'A limit ár mezőt a legjobb vételi és legjobb eladói oldal közötti középárral tölti ki.',
      instrumentNotLoaded: 'A középárat nem sikerült betölteni',
    },
    accountSelectInfo: `A folytatáshoz`,
    accountSelectInfoLink: `válassz számlát!`,
  },
  orderbook: {
    quantity: 'Mennyiség',
    sell: 'Eladás',
    buy: 'Vétel',
    grid: {
      sellQuantity: 'Menny.',
      sellPrice: 'Eladás',
      buyPrice: 'Vétel',
      buyQuantity: 'Menny.',
    },
    selectInstrument: 'Nincs kiválasztva termék',
    nonTradeableInstrument: `Az instrumentumra ajánlat nem adható`,
    marketPrice: 'piaci',
  },
  productDetails: {
    tradingData: 'Kereskedési adatok',
    fundamentalIndicators: 'Fundamentális mutatók',
    selectInstrument: `Nincs kiválasztva termék`,
    noEstreamConnection: `Az árfolyam szolgáltatás jelenleg nem elérhető, a megjelenített adatok a legutóbbi elérhető termékadatok`,
    averagePriceInfo: 'VWAP, forgalommal súlyozott átlagár',
    cannotBeLoaded: 'A termék adatait nem sikerült betölteni',
    productDetailsFields: {
      high: 'Napi maximum',
      min: 'Min.',
      max: 'Max.',
      openPrice: 'Nyitó ár',
      low: 'Napi minimum',
      averagePrice: 'Átlagár',
      lastPrice: 'Utolsó kötés',
      previousLastPrice: `Előző utolsó kötés`,
      lastPriceTime: 'Utolsó kötés időpontja',
      closePrice: 'Előző záró',
      dailyChange: 'Napi változás ($currency$)',
      dailyChangePercent: 'Napi változás (%)',
      YTDChangePercent: 'YTD árfolyam változás (%)',
      annualLow: '52 heti minimum',
      annualHigh: '52 heti maximum',
      annualLowDate: '52 heti minimum dátuma',
      annualHighDate: '52 heti maximum dátuma',
      volumeQuantity: 'Forgalom (db)',
      volumeValue: 'Forgalom ($currency$)',
      marketCapitalization: 'Piaci kapitalizáció',
      earningsPerShareTTM: 'EPS (TTM)',
      priceToBookValue: 'P/BV',
      priceToEarnings: 'P/E (Várakozás)',
      priceToEarningsTTM: 'P/E (TTM)',
      priceToSalesTTM: 'P/S (TTM)',
      dividend: 'Osztalék ($currency$)',
      dividendYield: 'Osztalékhozam (%)',
      dividendYield5Years: '5 éves osztalékhozam (%)',
      EBITDA: 'EBITDA',
      ROE: 'ROE (TTM)',
      ROA: 'ROA (TTM)',
      tenDayAverageVolume: `10 napos átlagforgalom(mennyiség)`,
    },
    instrumentFields: {
      name: 'Név',
      isin: 'ISIN',
      instrumentCategory: 'Termék kategória',
      marketCode: 'Piac',
      currencyCode: 'Devizanem',
    },
    high: 'Napi maximum',
    highShort: 'Napi max.',
    instrumentData: 'Általános adatok',
    min: 'Min.',
    max: 'Max.',
    openPrice: 'Nyitó ár',
    low: 'Napi minimum',
    lowShort: 'Napi min.',
    averagePrice: 'Átlagár',
    lastPrice: 'Utolsó kötés',
    previousClose: 'Előző záró',
    dailyChange: 'Napi változás (HUF/EUR/USD)',
    dailyChangePercent: 'Napi változás (%)',
    YTDChangePercent: 'YTD árfolyam változás (%)',
    annualLow: '52 heti minimum',
    annualHigh: '52 heti maximum',
    volumeQuantity: 'Forgalom (db)',
    volumeValue: 'Forgalom (HUF)',
    marketCapitalization: 'Piaci kapitalizáció',
    earningsPerShareTTM: 'EPS (TTM)',
    priceToBookValue: 'P/BV',
    priceToEarnings: 'P/E (Várakozás)',
    priceToEarningsTTM: 'P/E (TTM)',
    priceToSalesTTM: 'P/S (TTM)',
    dividend: 'Osztalék',
    dividendYield: 'Osztalékhozam',
    dividendYield5Years: '5 éves osztalékhozam',
    EBITDA: 'EBITDA',
    ROE: 'ROE',
    ROA: 'ROA',
    isin: 'ISIN',
    instrumentCategory: 'Termék kategória',
    marketCode: 'Piac',
    currencyCode: 'Devizanem',
  },
  openPositions: {
    openPositions: `Nyitott pozíciók`,
    all: `Összes`,
    grid: {
      instrumentBase: 'Termék',
      instrument: `Ticker`,
      position: `Mennyiség`,
      initValue: `Beker. átlagár`,
      initPriceValue: `Befektetett összeg`,
      value: `Piaci érték`,
      pNLDaily: `Napi P&L`,
      pNL: `Össz P&L`,
      pNLPercentage: `Össz P&L %`,
      tradeType: `Ügylet típusa`,
      currency: `Deviza`,
      accountId: `Számla`,
      instrumentName: 'Név',
      mic: 'Piac',
    },
    modalGrid: {
      instrument: `Termék`,
      tradeType: `Ügylet típusa`,
      quantity: `Mennyiség`,
      transactionValue: `Tranzakció értéke`,
      commission: `Jutalék`,
      info: `Infó`,
    },
    info: `Infó`,
    infoOnline: `Online nem kereskedhető termék`,
    infoMifid: `Az instrumentum kereskedése a Mifid teszt eredménye alapján nem alkalmas az Ön számára.`,
    sell: 'Eladás',
    buy: 'Vétel',
    emptyList: 'Nincs nyitott pozíció.',
    cannotBeClosed: `Az alábbi pozíciók zárására nincsen lehetőség:`,
    marketPositionText: `A lent listázott tőzsdei pozíciók zárása céljából <strong>piaci típusú</strong> megbízás kerül létrehozásra:`,
    hufTransactionSum: `HUF Tranzakciók összértéke:`,
    expectedHufCommission: `Várható HUF jutalék`,
    usdTransactionSum: `USD Tranzakciók összértéke:`,
    expectedUsdCommission: `Várható USD jutalék:`,
    eurTransactionSum: `EUR Tranzakciók összértéke:`,
    expectedEurCommission: `Várható EUR jutalék:`,
    huf: `HUF`,
    usd: `USD`,
    eur: `EUR`,
    infoTitle: `A tőzsdén kívüli pozíciók ezen funkcióval nem kerülnek zárásra.`,
    infoText1: `Felhívjuk figyelmét, hogy az összes pozíció zárása funkció használatakor nem érvényesül a best execution irányelv. A pozíciók azon a piacon kerülnek zárásra, ahol eredetileg felvételre kerültek.`,
    infoText2_1: `Az`,
    infoText2_2: `ikonnal jelölt termékek kapcsán az Ön MIFID tesztje alapján nem rendelkezik kellő ismerettel.`,
    sureText: `Írja be az alábbi mezőbe a ZÁRÁS szót a megerősítéshez`,
    surePlaceholder: `ZÁRÁS`,
    sure: 'ZÁRÁS',
    closeAll: `Összes zárása`,
    notes: `Megjegyzés`,
    order: `Megbízás`,
    more: 'Továbbiak',
    setColumns: `Oszlopok beállítása`,
    inventoryCannotBeTraded: `Az instrumentum jelenleg nem kereskedhető a rendszerben. Próbáld meg a régi Netbrokerben vagy offline csatornáinkon`,
    closePositionTooltip: `Pozíció zárása`,
    noteTooltip: `Jegyzet`,
  },
  orderModal: {
    order: `Megbízás`,
    instrumentSearchPlaceholder: `pl Termék neve, ticker, ISIN`,
    confirmOrder: `Megbízás megerősítése`,
    confirmSell: 'Eladási megbízás összesítése',
    confirmBuy: 'Vételi megbízás összesítése',
    orderDetails: `Megbízás részletei`,
    additionalSettings: `További beállítások`,
    transactionType: `Ügylet típusa`,
    orderType: `Megbízás típusa`,
    quantity: `Mennyiség`,
    quantityEndorment: `db`,
    limit: `Limitár`,
    stopPrice: `Aktiválási ár`,
    timeInForce: `Érvényesség`,
    stockValuation: `Készletértékelés`,
    tradingRestrictions: `Kereskedési szakasz`,
    exchange: `Devizaváltás`,
    exchangeTransaction: `Devizatranzakció`,
    sell: 'Eladás',
    buy: 'Vétel',
    max: `Max`,
    bestBid: 'Legjobb vevő',
    midPrice: 'Középárfolyam',
    bestAsk: 'Legjobb eladási',
    createOrderSuccess: 'Megbízás sikeresen leadva',
    orderExchangeSuccess: 'Devizatranzakció sikeresen leadva',
    modifyOrderSuccess: 'Megbízás sikeresen módosítva',
    errors: {
      quantityInput: {
        quantityEmpty: 'A megbízás mennyisége nem lehet üres!',
        quantityIsZero: 'A megbízás mennyisége minimum 1db!',
      },
    },
    bottomNavigation: {
      overviewSell: 'Eladási megbízás előnézete',
      overviewBuy: 'Vételi megbízás előnézete',
    },
    orderWarningConfirm: {
      warnTitle: 'Figyelem ($messageNumber$)',
      errorTitle: 'Hiba ($messageNumber$)',
    },
    exchangeDetails: {
      transactionValue: 'Tranzakció értéke',
      commission: 'Jutalék',
      availableBalance: 'Rendelkezésre álló egyenleg',
      missingValue: 'Hiányzó összeg',
    },
    exchangeNotes: {
      currentlyNoExchangePeriod: 'Jelenleg nincs devizaváltási időszak',
      currentlyNoExchangeTechnical: 'Jelenleg a devizaváltás technikai okokból szünetel',
      tryLaterFixTime: 'Próbáld újra az alábbi időpontokban:',
    },
    preValidateWarnings: {
      NYESZNotAllow: 'A kiválasztott instrumentum kereskedése nem engedélyezett $account$ számlán.',
      instrumentNotShortable: 'A kiválasztott instrumentumra short ügylet nem rögzíthető',
      shortWarning: `Shortot eredményező megbízást készülsz rögzíteni. A 'Folytatás' gomb megnyomásával elfogadod az Internetes day-trade short szolgáltatás feltételeit. Folytatod a tranzakciót?`,
      allowShortTradeMissing:
        'Kiegészítő megállapodás komplex ügyletekre szerződés hiánya miatt short ügylet nem rögzíthető.',
      insufficientCash: `Kiegészítő megállapodás komplex ügyletekre szerződés hiánya miatt befektetési hitelt igénylő ügylet nem rögzíthető.`,
      insufficientCashWithLoan:
        'A megbízásban megadott paraméterek alapján az ügylet teljesülése befektetési hitel felvételét vonja maga után!',
      buxFutureTradeMissing:
        'Kiegészítő megállapodás komplex ügyletekre szerződés hiánya miatt termékre megbízás nem rögzíthető.',
      invalidStopActivationPrice: 'Hibás aktiválási ár! Megadott paraméterek alapján stop azonnal aktiválásra kerülne.',
    },
    twoFactorConfirm: {
      title: 'Kétfaktoros megerősítés',
      smsCode: 'SMS kód',
      info: 'Egy négyjegyű kódot küldtünk SMS-ben a beállításokban rögzített telefonszámra. Amennyiben az SMS nem érkezett meg, próbálj meg visszalépni és újra beküldeni a megbízást. Illetve ellenőrizni a telefonszám helyességét a beállításokban.',
      confirm: 'Megbízás megerősítése',
      restart: 'Vissza a megbízás megadásához',
    },
    transactionInfo: {
      title: 'Tranzakciós információk',
      debitAccount: 'Terhelendő számla',
      maxPosition: 'Maximálisan nyitható pozíció',
      currencyBalance: 'Deviza egyenleg',
      account: 'Számla',
      investable: 'Szabad pénz',
      allAccounts: 'Minden számla',
      selectAccountWarning: 'Válassz számlát a megbízás beküldéséhez',
      heldQuantity: 'Mennyiség',
      averagePrice: 'Átlagár',
      inventory: 'Készlet',
    },
    currencyExchange: {
      missingValue: 'Nincs elég $currency$ fedezet a tranzakcióhoz',
      notEnoughCurrencyBalance: 'A kiválasztott deviza nem fedezi a tranzakció hiányzó összegét.',
      notEnoughCurrencyBalanceToFullOrder: 'A kiválasztott deviza nem fedezi a teljes tranzakciót.',
    },
    currencyExchangeForm: {
      switchLabel: 'Deviza tranzakció',
      insufficientBalanceFull: 'A kiválasztott deviza egyenlege nem fedezi a teljes összeget.',
      insufficientBalanceMissing: 'A kiválasztott deviza egyenlege nem fedezi a hiányzó összeget.',
      notEnoughCashError: 'Nem elegendő a szabad pénz!',
      conditionsNotMetError: 'A megadott paraméterek alapján a devizatranzakció nem elérhető.',
      conditionsTooltip: {
        title: 'Devizatranzakcióhoz szükséges feltételek',
        conditions: {
          hasOtherCurrencyBalance: 'Az instrumentum devizájától eltérő deviza is rendelkezésedre áll.',
          accountNotExcluded: 'A kiválasztott számla engedélyezi a devizaváltást.',
          instrumentNotExcluded: 'A kiválasztott instrumentum devizaváltásra alkalmas.',
          orderTypeEligible: 'A megbízás típusa: Limit; Stop limit vagy OCO.',
          orderTradeTypeIsBuy: 'A megbízás iránya: Vétel.',
          modifiedTotalNotReduced: 'A módosított tranzakció összértéke nem lehet alacsonyabb mint az eredeti.',
        },
      },
      selectOtherCurrency: 'Kérünk válassz másik devizát.',
      noUseableCurrencyBalance:
        'Az összes jelenleg váltható deviza egyenleged kisebb mint 1 ezért nem tudsz devizatranzakciót indítani.',
      paymentMode: 'Fizetési mód',
      onlyMissing: 'Csak hiány pótlása',
      fullAmount: 'Teljes összeg',
      fullDifference: 'Teljes különbség',
      disabledValue: 'Nincs hiányzó összeg',
      selectCurrency: 'Deviza választása',
      orderValue: 'Megbízás értéke',
      differenceValue: 'Különbség értéke',
      commission: 'Jutalék',
      availableBalance: 'Szabad pénz',
      missingAmount: 'Hiányzó összeg',
      exchangeRate: 'Árfolyam',
      exchangeRateError: 'Nem sikerült betölteni az árfolyamot',
      serverError: 'Hiba történt a betöltés során.',
      exchangeAmount: 'Váltandó összeg',
      unavailableSchedule: 'Hétfő-Péntek 08:00-22:00',
    },
    transactionValue: 'Tranzakció értéke: $value$',
    transactionValueMarket: 'Tranzakció értéke: ~ $value$',
    futuresMarginRequirementSum: 'Fedezettségi követelmény: $value$',
    futuresNetValue: 'Nettó érték: $value$',
    priceIsZero: 'Túl alacsony érték! Az érték nem lehet $price$.',
    priceIsTooLow: 'Túl alacsony érték! Minimum megadható: $price$.',
    priceIsTooHigh: 'Túl magas érték! Maximum megadható: $price$.',
    priceHasInvalidTickSize: 'Az árlépésköz: $tickSize$',
    stopWouldActivateImmediately: 'Megadott paraméterek alapján stop azonnal aktiválásra kerülne.',
    priceValidationError: 'Hibás árlépésköz. Árlépésköz: $tickSize$',
    priceValidationErrorWithoutTickSize: 'Hibás árlépésköz.',
    priceValidationWarningWithoutTickSize: 'Az árlépésköz meghatározása sikertelen',
  },
  noteModal: {
    note: `Jegyzet`,
    lastSave: `Utolsó mentés`,
    placeholder: `Jegyzet írása`,
  },
  datePicker: {
    defaultFormat: 'yyyy.MM.dd',
  },
  orderConfirm: {
    rows: {
      accountName: 'Terhelendő számla',
      instrumentName: 'Termék neve',
      isin: 'ISIN',
      currencyCode: 'Devizanem',
      orderType: 'Megbízás típusa',
      orderTypeValues: {
        limit: 'Limit',
        stopLimit: 'Stop limit',
        market: 'Piaci',
        stopMarket: 'Stop piaci',
        oco: 'OCO',
      },
      tradeType: 'Ügylet típusa',
      tradeTypeValues: {
        buy: 'Vétel',
        sell: 'Eladás',
      },

      quantity: 'Mennyiség',
      commission: 'Jutalék',
      exchangeRate: 'Árfolyam',
      stopActivationPrice: 'Aktiválási ár',
      expiryType: 'Érvényesség',
      expiryTypeValues: {
        day: 'Nap',
        gtd: 'Getting Things Done',
        gtc: 'Visszavonásig',
      },
      tradingSession: 'Kereskedési szakasz',
      tradingSessionValues: {
        intraDay: 'Nyító szakasz',
      },
      price: 'Megbízás értéke',
      transactionSum: 'Tranzakció összértéke',
      currencyExchangeTitle: 'Devizatranzakció adatai',
      currency: 'Devizanem',
      exchangeDirection: 'Ügylet típusa',
      settlementDate: 'Elszámolás napja',
      currencyExchangeValue: 'Devizatranzakció értéke',
      futuresMarginRequirementSum: 'Fedezettségi követelmény',
      futuresNetValue: 'Nettó érték',
    },
    costCalculateError: 'Sikertelen költségkalkuláció',
    market: 'Piaci',
    preliminaryExpenses: 'Előzetes költségkimutatás',
  },
  newOrderConfirm: {
    accountSell: 'Terhelendő számla',
    accountBuy: 'Jóváírandó számla',
    orderType: 'Megbízás típusa',
    quantity: 'Mennyiség',
    limitPrice: 'Limit ár',
    activationPrice: 'Aktiválási ár',
    orderValue: 'Megbízás értéke',
    netValue: 'Nettó érték',
    commission: 'Jutalék',
    totalTransactionValue: 'Tranzakció összértéke',
    currencyCoverage: 'Deviza fedezet',
    exchangeRate: 'Devizaváltási árfolyam',
    settlementDate: 'Elszámolás napja',
    validity: 'Megbízás érvényessége',
    tradingSession: 'Kereskedési szakasz',
    preliminaryExpenses: 'Előzetes költségkimutatás',
    futuresMarginRequirement: 'Fedezettségi követelmény',
    stockValuation: 'Készletpárosítás',
    confirmBuy: 'Vételi megbízás beküldése',
    confirmSell: 'Eladási megbízás beküldése',
    freeCashCoverage: 'Szabad pénz fedezet',
    exchangeTotalValue: 'Devizaváltás összértéke',
  },
  newOrderTwoFactor: {
    title: 'Megbízás kétfaktoros megerősítése',
    content: 'Írd be a mentett telefonszámra SMS-ben kapott kódot a két faktoros hitelesítéshez',
    label: 'SMS kód',
  },
  numericFormat: {
    thousandSeparator: ' ',
    decimalSeparator: ',',
  },
  BETFillList: {
    grid: {
      ticker: `Ticker`,
      price: `Árfolyam`,
      quantity: `Mennyiség`,
      time: `Idő`,
    },
    nonTradeableInstrument: `Kizárólag a BÉT-en kereskedett instrumentumok esetén releváns elem`,
    emptyList: `Mai napon még nem történt kötés`,
  },
  openOrders: {
    grid: {
      instrument: `Ticker`,
      tradeType: `Ügylet típus`,
      quantity: `Mennyiség`,
      price: `Ár`,
      stopPrice: `Aktiválási ár`,
      orderType: `Megbízás típusa`,
      expiryType: `Érvényesség`,
      state: `Státusz`,
      accountId: `Számla`,
      instrumentName: 'Név',
      mic: 'Piac',
      currency: 'Deviza',
      filledQty: `Teljesített mennyiség`,
      orderValue: 'Megbízás értéke',
    },
    delete: `Összes visszavonása`,
    confirmDelete: `Biztosan visszavonod ezt a megbízást?`,
    confirmDeleteAll: `Biztosan visszavonod a számlán lévő összes nyitott megbízást?`,
    approve: `Visszavonás`,
    approveAll: `Összes visszavonása`,
    setColumns: `Oszlopok beállítása`,
    notes: `Megjegyzés`,
    cancelOrderTooltip: `Megbízás visszavonása`,
    editOrderTooltip: `Megbízás módosítása`,
    order: `Megbízás`,
    successCancelAllOrders: `Összes nyitott megbízás visszavonva`,
    successCancelOrder: `Megbízás visszavonva`,
    emptyList: 'Nincs nyitott megbízás.',
    error: 'Nyitott megbízások betöltése sikertelen',
  },
  tradeTypeOptions: {
    buy: 'Vétel',
    sell: 'Eladás',
  },
  orderTypeOptions: {
    limit: `Limit`,
    stopLimit: `Stop limit`,
    market: `Piaci`,
    stopMarket: `Stop piaci`,
    oco: `OCO`,
    iceberg: 'Iceberg',
  },
  inventoryManagementMethodOptions: {
    FIFO: `FIFO`,
    LIFO: `LIFO`,
    HIFO: `HIFO`,
    LOFO: `LOFO`,
  },
  tradingSessionOptions: {
    all: `Minden szakasz`,
    preMarket: `Elő piac`,
    afterMarket: `Utó piac`,
    openingAuction: `Nyitó szakasz`,
    underTrading: `Kereskedés alatt`,
    underTradingAuction: `Kereskedés alatt`,
    closingAuction: `Záró szakasz`,
    auction: `Aukció`,
    normal: `Normál kereskedési szakasz`,
  },
  expiryOptions: {
    day: `Nap`,
    gtd: 'Dátumig',
    gtc: 'Visszavonásig',
    fok: 'fok',
    ioc: 'ioc',
  },
  orderStateOptions: {
    'pre-submitted': 'Előkészített',
    submitted: 'Beküldött',
    active: 'Aktív',
    revoked: 'Visszavont',
    rejected: 'Visszautasított',
    partfilled: 'Részteljesített',
    filled: 'Teljesített',
    waiting: 'Várakozó',
    live: 'Élő',
    modified: 'Módosított',
    expired: 'Lejárt',
    inactive: 'Inaktív',
    'stop-inactive': 'Stop inaktív',
    'stop-activated': 'Stop aktivált',
    'wait-to-modify': 'Módosításra vár',
  },
  messageCenter: {
    onlyUnreads: `Csak olvasatlanok`,
    categories: {
      event: 'Események',
      promotion: 'Promóciók',
      technical: 'Technikai',
    },
    markAllAsRead: 'Összes megjelölése olvasottként',
    notificationsSettings: 'Értesítések beállításai',
    noNewAlert: 'Az elmúlt 7 napban nem érkezett új értesítés',
    noUnreadAlert: 'Nincs olvasatlan üzenet',
  },
  priceAlerts: {
    grid: {
      instrument: `Ticker`,
      condition: `Aktiválás feltétele`,
      activationPrice: `Árfolyamszint`,
      sentiment: `Várakozás`,
    },
    emptyList: `Nincs aktív árfolyamértesítés, kattints a láblécben található hozzáadás gombra új árfolyamértesítő hozzáadásához`,
    editAlert: `Riasztás módosítása`,
    deleteAlert: `Riasztás törlése`,
    deleteConfirm: `Biztosan törlöd az árfolyamértesítőt?`,
    editTooltip: `Értesítő módosítása`,
    deleteTooltip: `Értesítő törlése`,
    modal: {
      title: `Árfolyamértesítő`,
      stopPriceCondition: `Aktiválás feltétele`,
      exchangeRate: `Árfolyamszint`,
      sentiment: `Várakozás`,
      note: `Megjegyzés`,
      character: `karakter`,
      exchangeRateManagement: `Árfolyamértesítések kezelése`,
      info: `A(z) $instrument$ árfolyama $triggerState$ mint $price$, akkor aktiválásra kerül az árfolyamértesítő`,
      bearishTooltip: `Bearish`,
      bullishTooltip: `Bullish`,
      neutralTooltip: `Neutrális`,
      created: `Új árfolyamértesítő sikeresen hozzáadva!`,
      updated: `Árfolyamértesítő frissítve!`,
      alreadyPresent: 'A megadott adatokkal már létezik ilyen árfolyamértesítő!',
    },
    triggerState: {
      le: '≤ Kisebb vagy egyenlő',
      ge: '≥ Nagyobb vagy egyenlő',
    },
    triggerStateShort: {
      le: 'kisebb vagy egyenlő',
      ge: 'nagyobb vagy egyenlő',
    },
    title: `Árfolyamriasztások`,
  },
  orderLog: {
    orderLog: `Megbízási napló`,
    grid: {
      logEntryType: `Esemény`,
      tradeType: `Ügylet típ.`,
      ticker: `Instrumentum`,
      orderId: `Azonosító`,
      accountNumber: `Számla`,
      transactionDate: `Idő`,
      details: `Alelemek`,
      instrumentName: `Instrumentum neve`,
      tradeTypeFull: `Ügylet típusa`,
      orderType: `Megbízás típusa`,
      price: `Ár`,
      quantity: `Mennyiség`,
      validity: `Érvényesség`,
      stopPrice: `Aktiválási ár`,
    },
    periodOptions: {
      day: `Napi`,
      last7days: `Elmúlt 7 nap`,
      last14days: `Elmúlt 14 nap`,
      last30days: `Elmúlt 30 nap`,
    },
    emptyList: 'Nincs a szűrt időszakban megjeleníthető megbízás',
    parameters: `Megbízás paraméterei`,
    rejectReason: `Visszautasítás oka`,
  },
  eventType: {
    created: `Létrehozás`,
    modified: `Módosítás`,
    revoked: `Visszavonás`,
    filled: `Teljesülés`,
    rejected: `Visszautasítás`,
  },
  portfolio: {
    portfolio: `Portfólió`,
    collateralSummary: `Fedezet összesítő`,
    orderLog: `Megbízási napló`,
    openPositions: `Nyitott pozíciók`,
    openOrders: `Nyitott megbízások`,
    title: `Portfólió összetétel`,
    allAccounts: `Minden számla`,
    marketValueOfProducts: 'Termékek piaci értéke',
    accountsValue: 'Számlák összértéke',
    allInventory: 'Összes készlet',
    accounts: `Számlák`,
    cash: `Pénz`,
    instrumentClass: `Termékek`,
    investmentLoan: `Befektetési hitel`,
    accountValue: `Számlaérték`,
    investmentLoanTooltip: `A befektetési hitel értéke levonásra kerül a számlaértékből. A befektetési hitel értéke nem kerül vizualizációra a diagramon.`,
    grid: {
      instrumentCategory: `Termék kategória`,
      technical: `Technikai`,
      accountNumber: `Számla`,
      instrumentName: `Ticker`,
      ticker: `Ticker`,
      name: `Név`,
      quantity: `Mennyiség`,
      investmentAmount: `Befektetett összeg`,
      pNL: `Bruttó P&L`,
      pNLPercentage: `Bruttó P&L %`,
      valueInHuf: `Piaci érték (HUF)`,
      value: `Piaci érték`,
      weight: `Súly`,
    },
    accountGrid: {
      accountCategory: `Kategória`,
      account: `Név`,
      value: `Számlaérték`,
      pnl: `Nem realizált eredmény`,
      cashBalance: `Szabad pénz`,
      weight: `Súly`,
    },
    cashGrid: {
      account: `Számla`,
      ticker: `Ticker`,
      name: `Név`,
      inventory: `Készlet`,
      investable: `Szabad pénz`,
      weight: `Súly`,
    },
    resetColumns: `Oszlopok visszaállítása`,
    currencies: {
      HUF: 'Magyar Forint',
      USD: 'Amerikai Dollár',
      GBP: 'Angol Font',
      JPY: 'Japán Yen',
      CHF: 'Svájci Frank',
      EUR: 'Euro',
      CZK: 'Cseh Korona',
      PLN: 'Lengyel Zloty',
      SEK: 'Svéd Korona',
      CAD: 'Kanadai Dollár',
      ILS: 'Izraeli Shekel',
      AUD: 'Ausztrál Dollár',
      NOK: 'Norvég Korona',
      DKK: 'Dán Korona',
      HKD: 'Hongkongi Dollár',
      TRY: 'Török Líra',
      RON: 'Román Lej',
      BGN: 'Bolgár Leva',
      BRL: 'Brazil Real',
      SGD: 'Szingapúri Dollár',
      ISK: 'Izlandi Korona',
      UAH: 'Ukrán Hrivnya',
      RUB: 'Orosz Rubel',
      NZD: 'Új-zélandi Dollár',
      CNY: 'Kínai Jüan',
      ZAR: 'Dél-afrikai Rand',
      MXN: 'Mexikói Peso',
      RSD: 'Szerb Dínár',
      CNH: 'Chinese Offshore Yuan',
      KRW: 'Dél-koreai Won',
      MYR: 'Maláj Ringgit',
      THB: 'Thai Baht',
    },
    invest: `Befektetem`,
    emptyList: 'Nincs megjeleníthető számla.',
    account: `számla`,
    inventory: `Készlet`,
    gridAction: `Megbízás`,
    inventoryCannotBeTraded: `Az instrumentum jelenleg nem kereskedhető a rendszerben. Próbáld meg a régi Netbroker felületén vagy offline csatornáinkon. Amennyiben privát banki ügyfél vagy fordulj tanácsadódhoz.`,
    inventoryEqMissingRic:
      'Figyelem, a részvény azonosítókódja hiányzik! A részleteket és friss árfolyam adatokat a régi Netbrokerben találod.',
  },
  historicalPortfolioValue: {
    tabs: {
      '1m': '1 hónap',
      '3m': '3 hónap',
      ytd: 'YTD',
      '1y': '1 év',
      '3y': '3 év',
    },
    header: {
      title: 'Portfólió teljesítmény',
      subtitle:
        'Kövesd nyomon portfóliód értékét az idő múlásával. Vidd az egeret a diagramra a pontos dátumok és összegek megtekintéséhez',
    },
    chart: {
      months: {
        january: 'Jan',
        february: 'Feb',
        march: 'Már',
        april: 'Ápr',
        may: 'Máj',
        june: 'Jún',
        july: 'Júl',
        august: 'Aug',
        september: 'Szep',
        october: 'Okt',
        november: 'Nov',
        december: 'Dec',
      },
    },
  },
  collateralSummary: {
    title: `Fedezet összesítő`,
    nyeszEmptyText: `Tőkeáttétel nem használható NYESZ számlán.`,
    accountEmptyText: 'A számlán nem található fedezeti eszköz',
    tooltipText: `A Fedezet összesítő részletes leírását a Felhasználói kézikönyvben találod.`,
    legendTitles: {
      collateralValue: `Fedezeti érték`,
      guarantorAsset: 'Kezes vagyon',
      assetNonMarginSum: 'Eszközök értékelési tartaléka',
      positionNonMarginSum: 'Követelmények értékelési tartaléka',
      totalCollateralValue: 'Összes fedezet',
      marginRequirement: `Fedezeti követelmény`,
      warning: `Figyelmeztetési szint`,
      liquidation: `Likvidálási szint`,
      difference: 'Különbség',
      nonMargin: `Felszabadítható fedezet `,
    },
    legendTooltips: {
      collateralValue:
        'Az eszköz piaci értékének diszkonttényezővel csökkentett, pozíciók nyitására és nyitott tőkeáttételes pozíciók fedezésére használható értéke.',
      guarantorAsset: 'A kezes által a számlán biztosított többlet fedezet.',
      assetNonMarginSum: 'A fedezeti eszközök által biztosított értékelési tartalék.',
      positionNonMarginSum:
        'A fedezettségi követelménnyel járó pozíciók által (elsősorban letét követelmény formájában) biztosított értékelési tartalék',
      totalCollateralValue:
        'A saját eszközök fedezeti értéke, a számlán nyilvántartott pozíciók nettó nyereség fedezeti értéke és a kezes vagyon összesítve.',
      marginRequirement: `A tőkeáttételes pozíciók tartásához szükséges fedezet, a nyilvántartott pozíciók el nem számolt nettó vesztesége és a számlán keletkező díjtartozás összesítve.`,
      warning: `Az a szint, ami alatt felszólítás történik a fedezet feltöltésére a fedezettségi követelmény erejéig. Ennek hiányában kényszerlikvidálásra kerül sor.`,
      liquidation: `Az a szint, ami alatt felszólítás nélkül is kényszerlikvidálásra kerülhet sor annak érdekében, hogy a számla fedezett maradjon.`,
      marginRequirementThreshold: `Fedezeti követelmény: `,
      marginRequirementThresholdAndTotalCollateralDiff: `Fedezeti követelmény különbsége az összes fedezethez képest: `,
      warningThreshold: `Figyelmeztetési szint: `,
      warningThresholdAndTotalCollateralDiff: `Figyelmeztetési szint különbsége az összes fedezethez képest: `,
      liquidationThreshold: `Figyelmeztetési szint: `,
      liquidationThresholdAndTotalCollateralDiff: `Figyelmeztetési szint különbsége az összes fedezethez képest: `,
    },
    warnings: {
      belowMarginRequirement:
        'Az összes fedezeted nem éri el a fedezeti követelményt! Kérjük, hogy biztosítsd a hiányzó fedezetet pénz beutalás vagy pozíció zárás útján!',
      belowWarning:
        'Az összes fedezeted a figyelmeztetési szint alá esett. Kérjük, biztosítsd a hiányzó fedezetet, hogy elkerüld a kényszerlikvidálást!',
      belowLiquidation:
        'Az összes fedezeted a likvidálási szint alá esett. Kérjük, biztosítsd a hiányzó fedezetet, hogy elkerüld a kényszerlikvidálást!',
    },
    accordionTitles: {
      collateralInstrument: `Fedezeti eszközök`,
      collateralRequirement: `Fedezeti követelménnyel járó pozíciók`,
      loansAndDebts: `Hitelek és tartozások`,
      debtsAndGuarantors: `Adósok és kezesek`,
    },
    grid: {
      collateralSummaryAssets: {
        name: `Név`,
        discount: `Diszkontérték`,
        quantity: 'Mennyiség',
        price: 'Árfolyam',
        marketValue: `Piaci érték`,
        collateralValue: `Fedezeti érték`,
        nonMargin: `Értékelési tartalék`,
      },
      collateralSummaryPositions: {
        instrumentName: `Név`,
        quantity: `Mennyiség`,
        marginRequirement: `Fedezeti követelmény`,
        profitLossHuf: `Össz P&L`,
        nonMargin: 'Értékelési tartalék',
        discount: 'Kedvezmény',
      },
      collateralSummaryLoans: {
        name: `Név`,
        amount: `Mennyiség`,
        value: `Érték`,
        marginRequirement: `Fedezeti követelmény`,
      },
      collateralSummaryDebtorGuarantor: {
        clientId: `Ügyfélkód`,
        partyType: `Státusz`,
        name: `Név`,
        collateral: `Kezes vagyon/Kezességi limit`,
        debtor: `Adós`,
        guarantor: `Kezes`,
        guarantorAsset: 'Kezes vagyon',
      },
    },
  },
  tradingPage: {
    customLayout: {
      emptyLayoutText: 'A saját elrendezés kialakításához add hozzá az első widget-et',
      addWidgetHelperText: 'Widget hozzáadás',

      addWidgetModal: {
        title: 'Widget hozzáadása',
        favorites: 'Kedvencek',
      },

      newLayoutModal: {
        deleteConfirm: {
          title: 'Elrendezés törlése',
          content: `Biztosan törölni szeretnéd a(z) <strong>$layoutName$</strong> nevű elrendezést?`,
        },
        addEmptyLayout: 'Üres elrendezés hozzáadása',
        usersLayouts: 'Saját elrendezések',
        defaultLayouts: 'Alapértelmezett elrendezések',
        newLayoutDefaultName: 'Új elrendezés',
      },
    },
    predefinedLayouts: {
      basic: 'Alap',
      basicPlus: 'Alap+',
      general: 'Általános',
      bet: 'BÉT',
      cockpit: 'Aktív kereskedés',
      matrix: 'Mátrix',
      trading: 'Kereskedés',
      watchlist: 'Figyelőlista',
      foreign: 'Külföldi',
    },
    predefinedLayoutsPopover: {
      emptyLayout: 'Üres elrendezés hozzáadása',
      predefinedLayouts: 'Alapértelmezett elrendezések',
      myLayouts: 'Saját elrendezések',
    },
    layoutSelector: {
      error: {
        minLength: 'Az elrendezések nevei legalább $minLength$ karakterből kell állnia',
        maxLength: 'Az elrendezések nevei legfeljebb $maxLength$ karakter hosszú lehet',
        required: 'Az elrendezések nevei nem lehetnek üresek',
        layoutNameAlreadyPresent: 'Azonos névvel nem létezhet több layout',
        layoutIsEmpty: 'Üres layout nem menthető el',
      },
    },
    groupPicker: {
      header: 'Összelinkelés',
      description: `Válassz egy színt a widget csoportba helyezéséhez`,
      delink: 'Összelinkelés megszüntetése',
    },
  },
  dashboard: {
    marketHint: {
      title: `Elemzői ajánlás`,
      subTitle: `Kattints a részletekért!`,
      buttonText: `Felfedés`,
      actionButtonText: `Megbízás`,
      analysis: `Elemzés`,
      openExchangeRate: `Nyitási ár`,
      openDate: `Nyitás dátuma`,
      goalExchangeRate: `Célár`,
      stopExchangeRate: `Stop ár`,
      expectedProfit: `Elérhető nyereség`,
      risk: `Kockázat`,
    },
    marketHintEmpty: {
      text: `Friss ajánlásokért nézz vissza később!`,
      tipp: `Tipp`,
    },
    marketHintDisclaimer: {
      title: `Tájékoztatás`,
      text: `Az alábbiakban foglaltak nem minősülnek befektetésre való ösztönzésnek, befektetési tanácsadásnak, értékpapír vételére, eladására vonatkozó felhívásnak vagy ajánlatnak. A kapcsolódó elemzés marketingközlemény, nem a befektetéssel kapcsolatos kutatás függetlenségének előmozdítását célzó jogi követelményeknek megfelelően készült. Az értékpapírokba történő befektetés különböző kockázatokat hordoz magában, befektetési döntése meghozatala előtt ismerje meg terméktájékoztató anyagainkat:`,
      approve: `Elfogadom`,
    },
    carousel: {
      apply: `Megnyitás`,
      details: `Részletek`,
    },
  },
  settings: {
    userSettings: {
      title: `Felhasználói beállítások`,
      subtitle: `Felhasználóhoz kapcsolódó beállítások`,
      cookie: `Cookie kezelés`,
      loremIpsum: `Lorem ipsum dolor sit amet`,
      mandatoryCookie: `Használatot segítő sütik`,
      mandatoryDescription: `Ezen sütik feltétlenül szükségesek ahhoz, hogy a felhasználók böngészhessék honlapunkat, maradéktalanul és zökkenőmentesen használhassák annak funkciót, a honlapunkon keresztül elérhető szolgáltatásokat, és lehetőséget biztosítanak a látogató által megadott adatok, beállítások megjegyzésére, hogy azokat ne kelljen egy újabb látogatáskor ismételten rögzítenie.`,
      statisticsCookie: `Statisztikai sütik`,
      statisticsDescription: `Ezen sütik segítségével információt gyűjthetünk azzal kapcsolatban, hogyan használják látogatóink honlapunkat (pl. melyik oldalt nézte meg a látogató, annak mely részére kattintott, mennyi időt töltött az egyes oldalakon). Mindezek célja honlapunk és a rajta megtalálható funkciók szolgáltatások fejlesztése, ezáltal a felhasználói élmény javítása, a zavartalan és megfelelő színvonalú szolgáltatásnyújtás biztosítása.`,
      edit: `Szerkesztés`,
      twoFactor: `Kétfaktoros tranzaktálás`,
      twoFactorNoti: `A funkció bekapcsolásával mind a tőzsdei tranzakciók mind a devizaváltás folyamatok kétfaktoros hitelesítéssel kerülnek megerősítésre`,
      loremIpsum3: `Lorem ipsum dolor sit amet`,
      twoFactorActivation: `Kétfaktoros tranzaktálás aktiválása`,
    },
    siteSettings: {
      title: `Felület beállításai`,
      subtitle: `A felület működésével kapcsolatos beállítások`,
      display: `Megjelenítés`,
      displayMode: `Megjelenítési mód`,
      displayModeOptions: {
        light: `Világos nézet`,
        dark: `Sötét nézet`,
        auto: `Automatikus`,
      },
      resolutionMode: `Felbontásfüggő megjelenítés`,
      loremIpsum: `Lorem ipsum dolor sit amet`,
      loremIpsum2: `Lorem ipsum dolor sit amet`,
      loremIpsum3: `Lorem ipsum dolor sit amet`,
      language: `Nyelv`,
      chooseLanguage: `Nyelvválasztó`,
      sessionTimeout: `Inaktivitási kiléptetés`,
      sessionTimeoutInfo: `Az inaktivitási kiléptetés elem segítségével konfigurálható a felhasználói inaktivitást követő automatikus kiléptetés időpontja. Az alapértelmezett (15 perc) kiléptetéstől eltérő beállítás használata esetén fokozottan ügyelj számlád és szenzitív adatait biztonságára.`,
      sessionTimeoutConfirmDialog: {
        title: `Inaktivitási kiléptetés módosítása`,
        text: `Biztos elmented az új beállítást?`,
      },
      autoLogoutTime: `Automatikus kiléptetés időtávja`,
      defaultTime: `15 perc (alapértelmezett)`,
      orderDetails: `Megbízások alapértelmezett adatai`,
      orderDetailsInfo: `Az alapértelmezett adatok használatával konfigurálható, hogy megbízás kezdeményezésekor a kötjegy milyen paraméterekkel kerül automatikusan kitöltésre. Amennyiben ezeket nem változtatod meg a megbízás beküldése előtt a kötjegyen, akkor a megbízás ezekkel az alapértelmezett paraméterekkel kerül beküldésre.`,
      validity: `Érvényesség`,
      tradingPhaseBET: `Kereskedési szakasz BÉT`,
      tradingPhaseUSA: `Kereskedési szakasz USA`,
      stockValuation: `Készletértékelés`,
      quantity: `Mennyiség`,
      piece: `db`,
      orderType: `Megbízás típus`,
      sessionTimeoutOptions: {
        Timeout15minutes: `15 perc (alapértelmezett)`,
        Timeout1hour: `1 óra`,
        TimeoutEndOfTheDay: `Nap vége`,
        Timeout4hours: `4 óra`,
      },
    },
    notificationsSettings: {
      title: `Értesítési beállítások`,
      subtitle: `Értesítésekkel kapcsolatos beállítások`,
      events: `Események`,
      notificationsGrid: {
        title: `Értesítések`,
        webPlatform: `Web platform`,
        pushNotification: `App push notification`,
        sms: `SMS`,
        email: `Email`,
        acceptanceOfOrder: `Megbízás befogadása`,
        fulfillmentOfOrder: `Megbízás teljesülése`,
        partialFulfillmentOfOrder: `Megbízás részleges teljesülése`,
        orderModification: `Megbízás módosítása`,
        cancelOrder: `Megbízás visszavonása`,
        rejectOrder: `Megbízás visszautasítása`,
      },
      promotionGrid: {
        title: `Promóciók`,
        marketingConsent: `Hozzájárulok marketing típusú megkereséshez`,
        notification: `Értesítések`,
        webPlatform: `Web platform`,
        pushNotification: `App push notification`,
        sms: `SMS`,
        email: `Email`,
        newWebinar: `Új webinár`,
        newErsteMarketHint: `Új Erste Market tipp`,
        action: `Akció`,
      },
    },
    dataServiceManagement: {
      title: `Adatszolgáltatási beállítások`,
      subtitle: `Valós idejű adatszolgáltatások áttekintése és módosítása`,
      discount: {
        title: '$name$ - Kedvezményes',
        description:
          'Az előfizetés automatikusan elindul a megadott időszakban, az időszak alatt nulla forint az előfizetési díj. Miután a kedvezményes időszak véget ér, az eredeti csomag automatikusan aktiválódik',
        fromTo: 'Kedvezményes időszak: $from$ - $to$',
      },
      statusActiveFromDate: 'aktív $from$',
      statusActiveFromToDate: 'aktív $from$ - $to$',
      statusFutureActiveFromDate: 'előfizetés kezdete: $from$',
      free: 'díjmentes',
      tooltip: {
        realTime1: `A legjobb árszint követése valós időben`,
        realTime5: `Az 5 legjobb árszint követése valós időben`,
        realTime10: `A 10 legjobb árszint követése valós időben`,
        delayed: `15 perccel késleltetett árfolyamok követése`,
      },
      loadingError: 'Hiba az előfizetések betöltése közben',
      successMessage: 'Sikeresen feliratkoztál a $subscriptionName$ előfizetésre.',
      discountedSubscriptionText: `Az előfizetés automatikusan elindul a megadott időszakban, az időszak alatt nulla forint az előfizetési díj. Miután a kedvezményes időszak véget ér, az eredeti csomag automatikusan aktiválódik`,
      feeNotes: `A szolgáltatás díja az adott hónap utolsó banki munkanapján kerül terhelésre.`,
      feeNotesForeign: `A szolgáltatás díja az adott hónap utolsó banki munkanapján érvényes hivatalos MNB devizaárfolyamon történő átszámítással, forintban kerül terhelésre.`,
      modalText: `Biztosan módosítod az adatszolgáltatási csomagot?<br><br>A módosítások véglegesítéséhez nyomd meg a “Módosítás” gombot, ellenkező esetben a “Mégsem” gombot.<br>
A módosítás elfogadásával a szerződési feltételek is elfogadásra kerülnek.`,
      termsOfConditions: `Szerződési feltételek`,
      termsOfConditionsText: `Szerződési feltételek valós idejű tőzsdei információk szolgáltatására. A nem személyre szabott tartalmakra hatással van például az éppen megtekintett tartalom, az aktív keresési munkamenetben végzett tevékenység és a tartózkodási hely. A nem személyre szabott hirdetésekre hatással van az éppen megtekintett tartalom és az általános tartózkodási hely. A személyre szabott tartalmak és hirdetések közé tartozhatnak egyebek mellett a relevánsabb találatok és javaslatok, valamint a személyre szabott hirdetések, amelyek az ebben a böngészőben végzett korábbi tevékenységeken (például korábbi Google-kereséseken) alapulnak. A cookie-kat és adatokat arra is felhasználjuk, hogy a felhasználói élményt az életkornak megfelelően szabjuk személyre, amennyiben ez szükséges. A nem személyre szabott tartalmakra hatással van például az éppen megtekintett tartalom, az aktív keresési munkamenetben végzett tevékenység és a tartózkodási hely. A nem személyre szabott hirdetésekre hatással van az éppen megtekintett tartalom és az általános tartózkodási hely. A személyre szabott tartalmak és hirdetések közé tartozhatnak egyebek mellett a relevánsabb találatok és javaslatok, valamint a személyre szabott hirdetések, amelyek az ebben a böngészőben végzett korábbi tevékenységeken (például korábbi Google-kereséseken) alapulnak. A cookie-kat és adatokat arra is felhasználjuk, hogy a felhasználói élményt az életkornak megfelelően szabjuk személyre, amennyiben ez szükséges.`,
    },
    versions: {
      title: 'Szoftver verziók',
      subtitle: 'A frontend és a kapcsolódó 3rd party alkalmazások aktuális verziószámai',
    },
  },
  chart: {
    chartModal: {
      continue: `Tovább`,
    },
    error: {
      invalid: `Hiba a grafikon betöltése közben, próbáld később`,
    },
  },
  errorWidgetContent: {
    title: 'Hiba történt a betöltés során',
    error: `Egyedi hibaazonosító:`,
    reload: 'Újratöltés',
  },
  instrumentCategory: {
    EQ: 'Részvény',
    FUT: 'Határidős termék',
    CRT: 'Certifikát',
    WAR: 'Warrant',
    ETF: 'ETF',
    FND: 'Befektetési alap',
    GB: 'Állampapír',
    BND: 'Kötvény',
    CN: 'Kárpótlási jegy',
    OPT: 'Opció',
    CCY: 'Deviza',
    SRP: 'Strukturált értékpapír',
    IND: 'Index',
    OTH: 'Egyéb',
  },
  feedbackModal: {
    title: 'Visszajelzés',
    description:
      'Oszd meg a véleményed az Erste Market PRO használatával kapcsolatban, és segíts nekünk jobbá tenni szolgáltatásainkat.',
    idea: 'Ötletem van',
    like: 'Tetszik',
    dislike: 'Nem tetszik',
    error: 'Hibát találtam',
    inputPlaceholder: {
      idea: 'Szerintem az Erste Market PRO-ban még jobb lenne ha...',
      like: 'Nekem az Erste Market PRO-ban tetszik...',
      dislike: 'Nekem az Erste Market PRO-ban nem tetszik...',
      error: 'Az Erste Market PRO-ban nem működik...',
    },
    send: 'Visszajelzés küldése',
    success: {
      title: 'Visszajelzésedet rögzítettük',
      description: 'Köszönjük, hogy segítesz fejleszteni a szolgáltatásainkat.',
    },
    fileDnd: {
      title1: 'Húzd ide a képernyő fotókat vagy ',
      titleLink: 'válassz a fájlokból',
      supportedFiles: 'Támogatott formátumok: JPEG, PNG, PDF',
      fileCount: '$current$/$max$ Fájl',
      fileSizes: '$current$/$max$ MB',
      fileTypeErrorTitle: 'Nem megfelelő fájl formátum',
      fileTypeErrorDescription:
        'A kiválaszott fájl formátuma nem megfelelő. Kizárólag JPEG, PNG és PDF formátumú fájlokat tudsz feltölteni.',
      error: {
        fileCannotBeUploaded: 'Sikertelen feltöltés A mellékletet nem lehet csatolni, mert elérte a limitet.',
      },
    },
  },
  markets: {
    nasdaq: 'Nasdaq',
    nyse: 'NYSE',
    frankfurt: 'Frankfurt',
    xetra: 'Xetra',
    wien: 'Bécs',
    bet: 'BÉT',
    beta: 'BÉTa',
    xtend: 'Xtend',
    london: 'London',
    otc: 'OTC',
  },
  codeInput: {
    character: 'SMS kód karakter $index$/$codeLength$',
  },
  codeInputModal: {
    defaultTitle: 'Kétfaktoros megerősítés',
    defaultInputLabel: 'SMS kód',
    defaultRestartLabel: 'Újra próbálkozás',
  },
  mobileAppBanner: {
    title: 'Kereskedj gyorsabban, reagálj hamarabb az Erste Market GO appal',
    item1: 'Mobil eszközre optimalizált működés',
    item2: 'Biometrikus és PIN kód azonosítás',
    item3: 'Nézz rá a portfóliódra és kereskedj kényelmesen',
    openApp: 'App megnyitása',
    stayInBrowser: 'Maradok a böngészőben',
    openErsteMarketGoIOS: 'Megnyitás az App Store-ban',
    openErsteMarketGoAndroid: 'Megnyitás az Play Store-ban',
    loaderText: 'Áirányítás a Store-ba',
  },
  twoFactorCodeInputModal: {
    turnOn: {
      description: 'A megbízások kétfaktoros megerősítésének bekapcsolásához add meg az SMS-ben kapott kódot.',
      technicalError: 'A megbízások kétfaktoros megerősítésének bekapcsolása sikertelen. Próbáld újra.',
      submitLabel: 'Bekapcsolás',
    },
    turnOff: {
      description: 'A megbízások kétfaktoros megerősítésének kikapcsolásához add meg az SMS-ben kapott kódot.',
      technicalError: 'A megbízások kétfaktoros megerősítésének kikapcsolása sikertelen. Próbáld újra.',
      submitLabel: 'Kikapcsolás',
    },
  },
};

export default translation;
